export default __webpack_public_path__ + "static/media/newlogo.b1b600fb.png";